module.exports = __webpack_public_path__ + "img/yuwen.edab19c3.png";